import React, { useEffect, useState } from 'react'
import './clockIn.css'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { userClockIn, userClockOut } from '../../api'
import { userLogin } from '../../state/userSlice'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content';

// Create a SweetAlert2 instance with React integration
const MySwal = withReactContent(Swal);




const ClockIn = () => {
    const {user} = useSelector((state)=>state.user)
    const dispatch = useDispatch()
    const [isDisabled, setIsDisabled] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [timeIn, setTimeIn] = useState()
    const [timeSpent, setTimeSpent] = useState()
    const [currentTime, setCurrentTime] = useState()


    const handleClockIn = async ()=> {
        setIsLoading(true)
        try {
            const res = await userClockIn(user?.token)
            if(res?.success){
                const newdata = {token: res?.token, ...res?.user}
                dispatch(userLogin(newdata))
                MySwal.fire({
                    icon: 'success',
                    title: res?.message + ' ' + currentTime,
                    showConfirmButton: false,
                    timer: 2000
                });
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            MySwal.fire({
                icon: 'error',
                title: 'Internal server error, Try again!',
                showConfirmButton: false,
                timer: 2000
            });
        }
    }
    
    const handleClockOut = async ()=> {
        setIsLoading(true)
        try {
            const res = await userClockOut(user?.token)
            if(res?.success){
                const newdata = {token: res?.token, ...res?.user}
                dispatch(userLogin(newdata))
                MySwal.fire({
                    icon: 'success',
                    title: res?.message + ' ' + currentTime,
                    showConfirmButton: false,
                    timer: 2000
                });
            }else{
                MySwal.fire({
                    icon: 'error',
                    title: res?.message,
                    showConfirmButton: false,
                    timer: 2000
                });
            }
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            console.log(error)
            MySwal.fire({
                icon: 'success',
                title: 'Internal server error, Try again!',
                showConfirmButton: false,
                timer: 2000
            });
        }
    }
    
    useEffect(()=>{
        const currentDate = new Date();
        const currentDay = currentDate.getDate();
        // Check if the current day is marked in the attendance array
        const isCurrentDayMarked = user?.attendance.some(item => {
            const currentMonth = moment().format('MMMM')
            if(item?.month === currentMonth){
                const isDay = item.days.some((d)=>{
                    if (d.day === currentDay && d.clockIn !== null) {
                        const clockInTime = moment(d.clockIn);
                        let clockOutTime = moment(); // Default to current time
    
                        if (d.clockOut) {
                            clockOutTime = moment(d.clockOut);
                        }
    
                        const formattedClockInTime = formatClockInTime(clockInTime);
                        const totalHoursSpent = calculateHoursSpent(clockInTime, clockOutTime);
                        
                        setTimeIn(formattedClockInTime)
                        setTimeSpent(totalHoursSpent)
                        setIsDisabled(true);
                    }
                })
            }
        });
    },[user])

    // Function to format the clock-in time
    const formatClockInTime = (clockInTime) => {
        return moment(clockInTime).format('h:mmA'); // Format the time as '8:45AM'
    };

    const calculateHoursSpent = (clockInTime, clockOutTime) => {
        const duration = moment.duration(clockOutTime.diff(clockInTime)); // Calculate the duration between clock-in and clock-out times
        const hours = Math.floor(duration.asHours()); // Get the total hours
        const minutes = duration.minutes(); // Get the remaining minutes
        const seconds = duration.seconds(); // Get the remaining seconds
    
        return `${hours}:${minutes}:${seconds}`;
    }

    useEffect(() => {
        // Update the current time every second
        const intervalId = setInterval(() => {
            setCurrentTime(moment().format('HH:mm:ss A'));
        }, 1000);

        // Clean up the interval on component unmount
        return () => clearInterval(intervalId);
    }, []);


  return (
    <div className="clock__in-box">
        <h4 className="clock__in-title">
            Self Attendance
        </h4>
        <div className="clock__in-box__item">
            <i class='bx bx-time-five clock__in-box__icon'></i>
            <span className="clock__in-box__time">{currentTime}</span>
            <div className="clock__in-box__buttons">
                <button onClick={handleClockIn}
                className={`clock__in-box__button button ${isDisabled || isLoading ? 'active' : ''}`}
                disabled={isDisabled ?? isLoading}>
                    {isLoading ? <i class='bx bx-rotate-right clock__in-icon'></i> : 'Check In'}
                </button>
                <button onClick={handleClockOut}
                className="clock__in-box__button button"
                disabled={isLoading}>
                    {isLoading ? <i class='bx bx-rotate-right clock__in-icon'></i> : 'Check Out'}
                </button>
            </div>
            <div className="clock__in-box__time-list">
                <div className="clock__in-box__checkin">
                    <span className="clock__in-box__time-title">Time In</span>
                    <span className="clock__in-box__time-in">
                        {timeIn}
                    </span>
                </div>
                <div className="clock__in-box__checkin">
                    <span className="clock__in-box__time-title">Duration</span>
                    <span className="clock__in-box__time-in">
                        {timeSpent}
                    </span>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ClockIn